<div class="homeSearchDesktop__content">
  <div class="homeSearchDesktop__shadows" (mouseenter)="mouseEvent(true)" (mouseleave)="mouseEvent(false)">
    <div class="homeSearchDesktop__shadow homeSearchDesktop__shadow--left" *ngIf="showPrev"></div>
    <div class="homeSearchDesktop__shadow homeSearchDesktop__shadow--right" *ngIf="showNext"></div>
    <div class="homeSearchDesktop__shadow homeSearchDesktop__shadow--btn-left" *ngIf="showPrev">
      <app-ds-button-icon
        *ngIf="hovered"
        [type]="buttonType"
        [icon]="icon.ChevronLeft"
        [buttonSize]="buttonIconSize"
        [iconSize]="20"
        (clickEvent)="scrollToMin()">
      </app-ds-button-icon>
    </div>
    <div class="homeSearchDesktop__shadow homeSearchDesktop__shadow--btn-right" *ngIf="showNext">
      <app-ds-button-icon
        *ngIf="hovered"
        [type]="buttonType"
        [icon]="icon.ChevronRight"
        [buttonSize]="buttonIconSize"
        [iconSize]="20"
        (clickEvent)="scrollToMax()">
      </app-ds-button-icon>
    </div>
  </div>
  <div class="homeSearchDesktop__slider" #slider (scroll)="detectChanges()" (mouseenter)="mouseEvent(true)" (mouseleave)="mouseEvent(false)">
    @if (groupSearchTabs) {
      @for (group of countryModulesCollection$ | async; track trackById) {
        @if (group?.['key']) {
          <div class="homeSearchDesktop__group-title">
            <app-ds-typography
              [tag]="'p'"
              [fontFamily]="fontFamily.Regular"
              [size]="fontSize.Smaller"
              [color]="fontColor.Secondary"
              [text]="group?.['key'] | transloco | uppercase">
            </app-ds-typography>
          </div>
        }
        @for (module of group?.['value']; track trackById) {
          <app-ds-chip-action
            [label]="module.title | transloco"
            [icon]="module.icon"
            [type]="chipActionType"
            [branding]="module.chipBranding"
            [chipStatus]="getChipStatus(moduleSelected(module.searchType))"
            (clickEvent)="onClickSwitch(module.searchType, module.route)">
          </app-ds-chip-action>
        }
      }
    } @else {
      @for (module of countryModulesCollection$ | async; track trackById) {
        <app-ds-chip-action
          [label]="module?.['title'] | transloco"
          [icon]="module?.['icon']"
          [type]="chipActionType"
          [branding]="module?.['chipBranding']"
          [chipStatus]="getChipStatus(moduleSelected(module?.['searchType']))"
          (clickEvent)="onClickSwitch(module?.['searchType'], module?.['route'])">
        </app-ds-chip-action>
      }
    }
  </div>

  <ng-container [ngSwitch]="switchSelected">
    <ng-container *ngSwitchCase="searchType.HOME_FLIGHT">
      <app-search-bar
        [searchType]="switchSelected"
        [airports]="airports$ | async"
        [source]="source">
      </app-search-bar>
    </ng-container>

    <ng-container *ngSwitchCase="searchType.HOME_HOTELS">
      <div class="homeSearchDesktop__content-hotel">
        <app-hotel-search
          [searchType]="switchSelected"
          [source]="source">
        </app-hotel-search>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="searchType.HOME_BUSES">
      <app-search-bar
        [searchType]="switchSelected"
        [airports]="airports$ | async"
        [source]="source">
      </app-search-bar>
    </ng-container>

    <ng-container *ngSwitchCase="searchType.PACKAGES_HOME">
      <app-packages-search-bar
        [searchType]="switchSelected"
        [source]="source">
      </app-packages-search-bar>
    </ng-container>

    <ng-container *ngSwitchCase="searchType.TOUR_AND_ACTIVITIES">
      <app-activities-search-bar
        [source]="source">
      </app-activities-search-bar>
    </ng-container>

    <ng-container *ngSwitchCase="searchType.HOME_BYHOURS">
      <app-no-module-available [searchType]="switchSelected"></app-no-module-available>
    </ng-container>

    <ng-container *ngSwitchCase="searchType.HOME_AUTOS">
      <app-no-module-available [searchType]="switchSelected"></app-no-module-available>
    </ng-container>

  </ng-container>
</div>